import { drivers } from '../config';
export = drivers.mysql2;
